export default __webpack_public_path__ + "static/media/devil.f3e7e2e0.jpg";